<template>
  <div class="main-container">
    <div id="app">
      <vue-snotify></vue-snotify>
      <div id="dialog-root"></div>
      <side-bar-component v-if="showSideBar" />
      <div class="view-container">
        <header-component v-if="showSideBar" />
        <router-view class="view" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    HeaderComponent: () => import("./components/Header.vue"),
    SideBarComponent: () => import("./components/SideMenu.vue"),
  },
  data: () => ({
    title: "Alert",
    HideSideBarRoutes: {
      login: true,
      register: true,
      "forgot-password": true,
      "registration-confirm": true,
      "reset-password": true,
    },
    timeOut: null,
  }),
  computed: {
    showSideBar() {
      return this.HideSideBarRoutes[this.$route.name] ? false : true;
    },
    exp() {
      return this.$store.getters.expirationTime;
    },
  },
  watch: {
    exp(d) {
      this.setTimeoutForExpirationTime(d);
    },
  },
  created() {
    this.setTimeoutForExpirationTime(this.exp);
  },
  methods: {
    setRoutePath() {
      const { fullPath } = this.$route;
      const { email } = this.$store.getters.getUser;
      this.$store.commit("setRoutePath", { fullPath, email });
    },
    setTimeoutForExpirationTime(time) {
      clearTimeout(this.timeOut);

      if (!time) {
        return;
      }

      const exp_time = new Date(time).getTime();
      const date_now = Date.now();
      const relative_time = exp_time - date_now;
      const m = 60 * 1000;
      const EXP_TIME = relative_time - m;

      this.timeOut = setTimeout(() => {
        this.setRoutePath();
        this.$store.dispatch("logout");
      }, EXP_TIME);
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style lang="scss">
@import url("./assets/fonts/Circular-Std/stylesheet.css");
@import url("./assets/fonts/Helvetica/stylesheet.css");
@import url("./assets/fonts/SF/stylesheet.css");
@import "~vue-snotify/styles/material";
html {
  width: 100%;
  height: 100%;
}
body {
  width: 100%;
  height: 100%;
  margin: 0;
  background-color: #f8f9fe !important;
}
p {
  margin: 0;
}
input {
  padding: 0;
  box-sizing: border-box;
}
select {
  background-color: transparent;
  border: none;
  box-sizing: border-box;
  -webkit-appearance: none;
}
select:focus {
  outline: none;
}
input:focus {
  outline: none;
}
button:focus {
  outline: none;
}
#app {
  height: 100vh;
  overflow: hidden;
  width: 100%;
  display: flex;
  .view-container {
    width: 100%; //78%;
    height: 100%;
    overflow: auto;
  }
}
.primary-button {
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  background-color: #51a3f3;
  color: #ffffff;
  font-family: "Helvetica Neue";
  font-size: 15px;
  font-weight: 500;
  line-height: 30px;
  text-align: center;
}
.link {
  cursor: pointer;
  color: #51a3f3;
  font-family: "Helvetica Neue";
  font-size: 16px;
  line-height: 20px;
}
.view {
  //height: calc(100vh - 60px);
  overflow: auto;
}
.is-danger {
  input {
    border-color: red !important;
    font-family: "Helvetica Neue" !important;
    font-size: 16px !important;
  }
  .primary-select-wrapper {
    border-color: red !important;
    font-family: "Helvetica Neue" !important;
    font-size: 16px !important;
  }
}
.help {
  color: red !important;
  font-family: "Helvetica Neue" !important;
  font-size: 12px !important;
  text-align: left;
  align-self: flex-start;
}
.noselect {
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome and Opera */
}
.white_space{
  white-space: nowrap;
}
</style>
